import React from "react";
import clsx from 'clsx';
import RateSelect from "../../Selects/RateSelect";
import CancellationRuleSelect from "../../Selects/CancellationRuleSelect";
import GuestTypeSelect from "../../Selects/GuestTypeSelect";
import FeeSelect from "../../Selects/FeeSelect";
import ProductSelect from "../../Selects/ProductSelect";
import DatePickerInput from '../../DatePickerInput/DatePickerInput';
import DateRangePicker from '../../DateRangePicker/DateRangePicker'
import FoliosSelect from "../../Selects/FoliosSelect";
import CurrencyInput from "../../CurrencyInput/CurrencyInput";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import Switch from "../../Switch/Switch";
import DataTable from "../../DataTable/DataTable";
import DateHelper from '../../DateHelper/DateHelper';
import ProductFolioItemBuilderErrors from "../ProductFolioItemBuilderErrors";



class ProductFolioItemBuilderGeneral extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    var self = this;
    // $(window).on("refresh_data_table", function () {
    //   self.props.calculatePrice()
    // });  
  }


  renderItemSelect() {
    // console.log("this.props", this.props);
    if (this.props.room_revenue) {
      return(
        <div>
          <label>{I18n.t('rate')}*</label>
          <RateSelect name="rate" add_charge={true} start_date={this.props.check_in_date} remote_path={this.props.add_charge_rates_remote_path} end_date={this.props.item_date} rate={this.props.rate} room_type={this.props.room_type} onChange={this.props.onChangeRate} />
        </div>
      )

    } else if (this.props.cancellation_fee) {
      return(

        <div>

          <label>{I18n.t('cancellation_rule')}*</label>
          <CancellationRuleSelect name="cancellation_rule" all_cancellation_rules={this.props.all_cancellation_rules} cancellation_rule={this.props.cancellation_rule} onChange={this.props.onChangeCancellationRule} />
        </div>
      )


    } else if (this.props.guest_fee) {
      return(
        <div>

          <label>{I18n.t('guest_type')}*</label>
          <GuestTypeSelect name="guest_type" all_guest_types={this.props.all_guest_types} guest_type={this.props.guest_type} onChange={this.props.onChangeGuestType} />
        </div>

      )

    } else if (this.props.fee_type) {
      return(
        <div>
          <label>{I18n.t('fee')}*</label>
          <FeeSelect fee={this.props.fee} all_fees={this.props.all_fees} onChange={this.props.onChangeFee} />

        </div>
      )
    } else {
      return(
        <div>
          <label>{I18n.t('product')}*</label>
          <ProductSelect product={this.props.product ? this.props.product : null} onChange={this.props.onChangeProduct} />
        </div>
      )
    }


  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'folio-item-general',
      'tab-pane': true,
      'product-folio-item': true,
    })

    var folio_item = {
      subtotal: this.props.amount,
      total_amount: this.props.amount * this.props.quantity,
      folio_id: this.props.folio ? this.props.folio.id : null,
      item_date: this.props.item_date,
      product_id: this.props.product ? this.props.product.id : null,
      quantity: this.props.quantity,
      rate_id: this.props.rate ? this.props.rate.id : null,
      guest_type_id: this.props.guest_type ? this.props.guest_type.id : null,
      room_type_id: this.props.room_type ? this.props.room_type.id : null,
      fee_id: this.props.fee ? this.props.fee.id : null,
    }


    return(
      <div className={tabClasses} id="folio-item-general">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <div className="panel panel-default">
                <div className="panel-body container">
                  <h5 className="panel-heading-text" style={{ paddingBottom: 20, paddingTop: 10 }}>{I18n.t('item_details')}</h5>
                  <div className="row">
                    <div className="col-sm-3 form-group">

                      {this.renderItemSelect()}

                    </div>

                    {this.props.date_range ? 
                        <DateRangePicker
                          startDateLabel="start_date"
                          endDateLabel="end_date"
                          dateFormat={this.props.date_format}
                          onChange={this.props.onChangeDates}
                          startDate={this.props.start_date ? this.props.start_date : new Date()}
                          endDate={this.props.end_date ? this.props.end_date : new Date(new Date().setDate(new Date().getDate() + 1))}                          
                          skip_label_style={true}
                          // minDate={this.props.current_property_date}
                          // maxDate={this.props.maxDate}
                          maxDays={29}
                          pickerClasses="col-md-6"
                          onToggleDate={this.props.onChangeDateRange}
                          componentVisisibleAction={this.props.setDateRangePickerVisibility}
                          // mobileVisibilityComponentAction={this.setDateRangePickerVisibility}
                        />
                        // <a href="#" onClick={this.props.onChangeDateRange.bind(null, false)}>+{I18n.t('item_date')}</a>
        
                      
                      : 
                      <div className="col-sm-3">
                        <label>{I18n.t('item_date')}*</label>
                          <DatePickerInput
                          name="item_date"
                          selectedDate={new Date(this.props.item_date)}
                          onChange={this.props.onChangeItemDate}
                          dateFormat={DateHelper.rubyToDateFNS(this.props.dateFormat)}
                          />
                        { !this.props.edit_booking && !this.props.edit ? <a href="#" onClick={this.props.onChangeDateRange.bind(null, true)}>+{I18n.t('add_date_range')}</a> : null}
                      </div>
                    }
                    
                    

                        
              
                   
                    {
                      this.props.folio
                        ?
                      <div className="col-sm-3">
                        <label>{I18n.t('folio')}*</label>
                        <FoliosSelect folio={this.props.folio} reservation_segment_id={this.props.reservation_segment ? this.props.reservation_segment.id : null} onChange={this.props.onChangeFolio} />
                      </div>
                        :
                      null
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            this.props.product || this.props.rate || this.props.cancellation_rule || this.props.guest_type || this.props.fee
            ?
            <div className="col-md-6">
                <div className="panel panel-default">
                  <div className="panel-body container">
                    <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('item_amount')}</h5>
                    <div className="row">
                      <div className="col-lg-3 form-group">
                        <label>{I18n.t('amount')}</label>
                        <CurrencyInput className="form-control" name="amount" value={this.props.amount || this.props.amount == 0 ? this.props.amount : 0} onBlur={this.props.onChangeAmount}  />
                      </div>
                      <div className="col-lg-4 form-group">
                        <label>{I18n.t('quantity')}</label>
                        <NumberSpinner value={this.props.quantity} onChange={this.props.onChangeQuantity} />
                      </div>
                      <div className="col-lg-5 form-group">
                        <label>{I18n.t('calculate_taxes_and_fees')}</label>
                        <Switch
                          onText="inclusive"
                          offText="exclusive"
                          switchId="calculate-taxes-and-fees"
                          value={this.props.calculate_taxes_and_fees}
                          onChange={this.props.onChangeCalculateTaxesAndFees}
                        />
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            :
            null
          }

        </div>
        {
          this.props.product || this.props.rate || this.props.cancellation_rule || this.props.guest_type || this.props.fee
          ?
            <div className="panel panel-default">
              <div className="panel-body container">
                <DataTable
                  endpoint = {this.props.calculate_children_data_table_path}
                  folio_item = {folio_item ? folio_item : null}
                  reservation_segment_guest_types={this.props.reservation_segment && this.props.reservation_segment.reservation_segment_guest_types ? this.props.reservation_segment.reservation_segment_guest_types : null}
                  calculate_taxes_and_fees= {this.props.calculate_taxes_and_fees ? "inclusive" : "exclusive"}
                  item_type= {this.props.item_type}
                  tax_ids= {this.props.tax_ids}
                  // fee_ids= {this.props.fee_ids}
                  no_data_text = {I18n.t('none')}
                  currency_unit = {I18n.t('number.currency.format.unit')}
                  delimiter = {I18n.t('number.currency.format.delimiter')}
                  separator = {I18n.t('number.currency.format.separator')}
                  date_format = {this.props.date_format}
                  time_format = {this.props.time_format}
                  read_only = {this.props.read_only}
                />
              </div>
            </div>
          :
          null
        }

      </div>
    );
  };

  renderErrors() {
    var errors = ProductFolioItemBuilderErrors.general(this.props.errors);
    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1
        return <li key={idx}><b>&#x2022;</b> {error}</li>
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    };
  };

  
};

export default ProductFolioItemBuilderGeneral
